import { useSyncExternalStore } from 'react';

import locator from 'locator';

if (typeof window !== 'undefined') {
  const originalPush = window.history.pushState;

  window.history.pushState = function (...args) {
    originalPush.apply(this, args as any);
    window.dispatchEvent(new Event('pushstate'));
  };
}

const subscribe = (onStoreChange: () => void) => {
  window.addEventListener('pushstate', onStoreChange);
  window.addEventListener('popstate', onStoreChange);

  return () => {
    window.removeEventListener('pushstate', onStoreChange);
    window.removeEventListener('popstate', onStoreChange);
  };
};

const getSnapshot = () => locator.search;
const getServerSnapshot = () => locator.search;

type SetSearchParams = (updates: Record<string, string | null>) => void;

export const useSearchParams = (): [URLSearchParams, SetSearchParams] => {
  const search = useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  const searchParams = new URLSearchParams(search);

  const setSearchParams: SetSearchParams = updates => {
    const next = new URLSearchParams(window.location.search);

    Object.entries(updates).forEach(([key, value]) => {
      if (value === null || value === '') {
        next.delete(key);
      } else {
        next.set(key, value);
      }
    });

    const qs = next.toString();
    const url = qs ? `${window.location.pathname}?${qs}` : window.location.pathname;

    window.history.pushState(null, '', url);
  };

  return [searchParams, setSearchParams];
};
